<div class="faq-section">
  <div class="faq-container container">
    <div class="header">FAQ</div>
    <div class="faq">
      <div class="faq-block" :class="{ active: showed.indexOf(1) !== -1 }" @click="onClick(1)">
        <div class="faq-block-container">
          <div class="question">
            <p class="question-text">What Is Crypto Gaming United (CGU)?</p>
            <svg :class="showed.indexOf(1) !== -1 ? 'transition-svg' : ''" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26" height="26" rx="13" fill="#070707"></rect>
              <path d="M13.1212 6.729L13.1212 19.729M6.5 13.1092H19.5" stroke="white" stroke-linecap="round">
              </path>
            </svg>
          </div>
          <transition name="fade" :duration="{ enter: 200, leave: 1 }">
            <p v-if="showed.indexOf(1) !== -1" class="answer">
              Crypto Gaming United (CGU) is a platform for lending NFTs to blockchain gamers,
              helping them increase their earnings and access better opportunities on play-to-earn titles.
              CGU is the native currency of the CGU DAO, and takes the form of a BEP20 token with a total supply of 1
              billion.
            </p>
          </transition>
        </div>
        <hr class="faq-delimiter">
      </div>
      <div class="faq-block" :class="{ active: showed.indexOf(2) !== -1 }" @click="onClick(2)">
        <div class="faq-block-container">
          <div class="question">
            <p class="question-text">How can i buy CGU token?</p>
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26" height="26" rx="13" fill="#070707"></rect>
              <path d="M13.1212 6.729L13.1212 19.729M6.5 13.1092H19.5" stroke="white" stroke-linecap="round">
              </path>
            </svg>
          </div>
          <transition name="fade" :duration="{ enter: 200, leave: 1 }">
            <p v-if="showed.indexOf(2) !== -1" class="answer">
              CGU token is traded on <a
              href="https://pancakeswap.finance/swap?outputCurrency=0x747D74dB20cc422F39ab54EDB2A3Ce21f3C98AF1"
              target="_blank">PancakeSwap</a>, <a href="https://timex.io/private/trading/cguusdt"
                                                  target="_blank">TimeX</a>, <a
              href="https://www.bitrue.com/trade/cgu_usdt" target="_blank">Bitrue</a> and <a
              href="https://www.probit.com/app/exchange/CGU-USDT" target="_blank">ProBit Global</a>
            </p>
          </transition>
        </div>
        <hr class="faq-delimiter">
      </div>
      <div class="faq-block" :class="{ active: showed.indexOf(3) !== -1 }" @click="onClick(3)">
        <div class="faq-block-container">
          <div class="question">
            <p class="question-text">How does staking work for CGU?</p>
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26" height="26" rx="13" fill="#070707"></rect>
              <path d="M13.1212 6.729L13.1212 19.729M6.5 13.1092H19.5" stroke="white" stroke-linecap="round">
              </path>
            </svg>
          </div>
          <transition name="fade" :duration="{ enter: 200, leave: 1 }">
            <p v-if="showed.indexOf(3) !== -1" class="answer">
              CGU token holders deposit or lock their tokens in a smart contract, which acts as a kind of vault. The CGU
              ecosystem generates revenues from gamers earning income in different P2E and metaverse titles, as well as
              various other activities. These revenues are used to buy CGU tokens from the open market, increasing
              demand
              and helping to support the price.
              <br><br>
              The CGU purchased are then distributed to holders who stake their tokens in the CGU smart contract. Unlike
              many other platforms, CGU allows holders to earn proportionally more by committing to locking their tokens
              for a longer period of time.
            </p>
          </transition>
        </div>
        <hr class="faq-delimiter">
      </div>
      <div class="faq-block" :class="{ active: showed.indexOf(4) !== -1 }" @click="onClick(4)">
        <div class="faq-block-container">
          <div class="question">
            <p class="question-text">Is there a minimum amount of CGU tokens to be staked?</p>
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26" height="26" rx="13" fill="#070707"></rect>
              <path d="M13.1212 6.729L13.1212 19.729M6.5 13.1092H19.5" stroke="white" stroke-linecap="round">
              </path>
            </svg>
          </div>
          <transition name="fade" :duration="{ enter: 200, leave: 1 }">
            <p v-if="showed.indexOf(4) !== -1" class="answer">
              No, there is no minimum amount of CGU needed to be staked.
            </p>
          </transition>
        </div>
        <hr class="faq-delimiter">
      </div>
      <div class="faq-block" :class="{ active: showed.indexOf(5) !== -1 }" @click="onClick(5)">
        <div class="faq-block-container">
          <div class="question">
            <p class="question-text">How often will the staking rewards be distributed?</p>
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="26" height="26" rx="13" fill="#070707"></rect>
              <path d="M13.1212 6.729L13.1212 19.729M6.5 13.1092H19.5" stroke="white" stroke-linecap="round">
              </path>
            </svg>
          </div>
          <transition name="fade" :duration="{ enter: 200, leave: 1 }">
            <p v-if="showed.indexOf(5) !== -1" class="answer">
              Currently, staking rewards distributed once a week.
            </p>
          </transition>
        </div>
        <hr class="faq-delimiter">
      </div>
    </div>
  </div>
</div>
